import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Icon, ThemeToggle } from '@librerank/ui';
import { UserMenu } from './UserMenu';
import { useWorkspace } from '../hooks/useWorkspace';

interface HeaderProps {
  children?: React.ReactNode;
  workspaceId?: string;
}

export const Header: React.FC<HeaderProps> = ({ children, workspaceId }) => {
  const { workspace, isModerator } = useWorkspace(workspaceId);
  const location = useLocation();

  const isAdminPage = location.pathname.includes('/admin/');

  return (
    <header className="header">
      <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none', color: 'inherit' }}>
          <Icon style={{ width: '2rem', height: '2rem' }} />
          <h1 style={{ fontSize: '1.25rem', margin: 0, fontWeight: 700, letterSpacing: '-0.025em' }}>LibreRank</h1>
        </Link>
        
        {workspace && !isAdminPage && isModerator && (
          <Link 
            to={`/w/${workspace.slug}/admin/assessments`}
            style={{ 
              fontSize: '0.85rem', 
              color: 'var(--primary)', 
              textDecoration: 'none',
              fontWeight: 600,
              padding: '0.35rem 0.75rem',
              borderRadius: '6px',
              border: '1px solid var(--primary-muted)',
              background: 'var(--primary-muted-bg)'
            }}
          >
            Manage Workspace
          </Link>
        )}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', height: '100%' }}>
        {children}
        <div style={{ width: '1px', height: '24px', background: 'var(--border)', margin: '0 0.5rem' }} />
        <ThemeToggle className="hover:bg-secondary" />
        <UserMenu />
      </div>
    </header>
  );
};

